import { stepStatuses } from "../Applications/constants";

// user
export const LOGIN_PATH = '/iniciar-sesion'
export const REGISTER_PATH = '/registro'
export const ACCOUNT_VERIFICATION = '/usuario/verificar'

// recover password
export const RECOVER_PASSWORD = '/recuperar-contrasena'
export const RESET_PASSWORD = '/restablecer-contrasena'

// application
export const APPLICATIONS_PATH = '/solicitudes'
export const APPLY_PATH = `${APPLICATIONS_PATH}/:id`

export const APPLY_PROJECT_PATH = `${APPLY_PATH}/proyecto`
export const APPLY_SOLICITUDE_PATH = `${APPLY_PROJECT_PATH}/que-necesitas`
export const APPLY_NEEDS_PATH = `${APPLY_PROJECT_PATH}/para-que`
export const APPLY_PEOPLE_PATH = `${APPLY_PROJECT_PATH}/capital-humano`
export const APPLY_INFO_PATH = `${APPLY_PROJECT_PATH}/otros`

export const APPLY_ORGANIZATION_PATH = `${APPLY_PATH}/organizacion`
export const APPLY_DATA_PATH = `${APPLY_ORGANIZATION_PATH}/datos`
export const APPLY_ACTIVITY_PATH = `${APPLY_ORGANIZATION_PATH}/actividad`
export const APPLY_FINANCIAL_PATH = `${APPLY_ORGANIZATION_PATH}/finanzas`

export const APPLY_DOCUMMENTS_PATH = `${APPLY_PATH}/documentos`
export const APPLY_DOCUMMENTS_INFO_PATH = `${APPLY_DOCUMMENTS_PATH}/info`
export const APPLY_DOCUMMENTS_UPLOAD_PATH = `${APPLY_DOCUMMENTS_PATH}/adjuntar`

export const APPLY_FINISHED_PATH = `${APPLY_PATH}/gracias`

export const PROFILE = '/perfil'

export const pathByApplyStatus = {
  [stepStatuses.SOLICITUDE]: APPLY_SOLICITUDE_PATH,
  [stepStatuses.NEEDS]: APPLY_NEEDS_PATH,
  [stepStatuses.PEOPLE]: APPLY_PEOPLE_PATH,
  [stepStatuses.INFO]: APPLY_INFO_PATH,
  [stepStatuses.DATA]: APPLY_DATA_PATH,
  [stepStatuses.ACTIVITY]: APPLY_ACTIVITY_PATH,
  [stepStatuses.FINANCIAL]: APPLY_FINANCIAL_PATH,
  [stepStatuses.DOCUMENTS]: APPLY_DOCUMMENTS_PATH,
  [stepStatuses.FINISHED]: APPLY_FINISHED_PATH
}
